import {priceController} from "./priceController";

class fanObjParamsManager {
    static fillParam(fan, store, measurementTmp, param, fanObj, extensionInfo, number_of_fans) {
        let isValid = null;

        if (!this.isWorkPointValid(measurementTmp))
            return;

        switch (param) {
            case "temperature":
                isValid = this.fill_temperature(fan, store, fanObj);
                break;
            case "performance":
                isValid = this.fill_performance(measurementTmp, store, fanObj, number_of_fans);
                break;
            case "total_pressure":
                isValid = this.fill_total_pressure(measurementTmp, store, fanObj);
                break;
            case "static_pressure":
                isValid = this.fill_static_pressure(measurementTmp, store, fanObj);
                break;
            case "static_pressure_increase":
                isValid = this.fill_static_pressure_increase(measurementTmp, store, fanObj);
                break;
            case "dynamic_pressure":
                isValid = this.fill_dynamic_pressure(measurementTmp, store, fanObj);
                break;
            case "total_efficiency" :
                isValid = this.fill_total_efficiency(measurementTmp, store, fanObj);
                break;
            case "static_efficiency" :
                isValid = this.fill_static_efficiency(measurementTmp, store, fanObj);
                break;
            case "work_frequency":
                isValid = this.fill_work_frequency(measurementTmp, store, fanObj);
                break;
            case "noise":
                isValid = this.fill_noise(measurementTmp, store, fanObj);
                break;
            case "casing_dimensions":
                isValid = this.fill_casing_dimensions(fan, store, fanObj);
                break;
            case "air_density":
                isValid = this.fill_air_density(measurementTmp, store, fanObj);
                break;
            case "price":
                isValid = this.fill_price(fan, measurementTmp, store, fanObj, extensionInfo, number_of_fans);
                break;
            case "rotor_type":
                isValid = this.fill_rotor_type(measurementTmp, fanObj);
                break;
            case "number_of_poles":
                isValid = this.fill_number_of_poles(measurementTmp, fanObj);
                break;
            case "power_on_shaft":
                isValid = this.fill_power_on_shaft(measurementTmp, fanObj, number_of_fans);
                break;
            case "power_on_shaft_with_material":
                isValid = this.fill_power_on_shaft_with_material(measurementTmp, fanObj, number_of_fans);
                break;
            case "material_density":
                isValid = this.fill_material_density(measurementTmp, fanObj, number_of_fans);
                break;
            case "amperage_v1":
                isValid = this.fill_amperage_v1(measurementTmp, fanObj, store, number_of_fans);
                break;
            case "amperage_v2":
                isValid = this.fill_amperage_v2(measurementTmp, fanObj, store, number_of_fans);
                break;
            case "installed_power":
                break;
            case "pipeline_diameter":
                isValid = this.fill_pipeline_diameter(store, fanObj);
                break;
            case "minimum_amount_of_air_at_the_minimum_frequency":
                isValid = this.fill_minimum_amount_of_air_at_the_minimum_frequency(store, fan, measurementTmp, fanObj);
                break;
            case "characteristic_coefficient":
                isValid = this.fill_characteristic_coefficient(measurementTmp, fanObj);
                break;
            case "pipeline_average_speed":
                isValid = this.fill_pipeline_average_speed(store, measurementTmp, fanObj, number_of_fans);
                break;
            case "average_length_of_the_shredded_material":
                isValid = this.fill_average_length_of_the_shredded_material(store, measurementTmp, fanObj);
                break;
            case "minimum_frequency_on_the_inverter":
                isValid = this.fill_minimum_frequency_on_the_inverter(store, fan, measurementTmp, fanObj);
                break;
            case "material_amount":
                isValid = this.fill_material_amount(store, measurementTmp, fanObj);
                break;
            case "weight":
                isValid = this.fill_weight(fan, measurementTmp, fanObj);
                break;
            case "number_of_fans":
                isValid = this.fill_number_of_fans(fanObj);
                break;
            case "electrical_power":
                isValid = this.fill_electrical_power(fan, measurementTmp, fanObj, number_of_fans);
                break;
            case "maximum_rotor_speed":
                isValid = this.fill_maximum_rotor_speed(fan, measurementTmp, fanObj);
                break;
            case "average_rated_speed_of_the_fan":
                isValid = this.fill_average_rated_speed_of_the_fan(store, measurementTmp, fanObj);
                break;
            case "drive":
                isValid = this.fill_drive_select_params(fanObj, fan);
                break;
            case "fan_temperature_increase":
                isValid = this.fill_fan_temperature_increase(store, measurementTmp, fanObj);
                break;
            case "max_medium_temperature":
                isValid = this.fill_max_medium_temperature(fan, measurementTmp, fanObj);
                break;
            case "noise_lpa":
                isValid = this.fill_noise_lpa(store, measurementTmp, fanObj);
                break;
            case "noise_lwa":
                isValid = this.fill_noise_lwa(store, measurementTmp, fanObj, number_of_fans);
                break;


            default:
                console.error("Nie obsłużony parametr " + param);
                fanObj.params[param] = 0;
                break;
        }
    }

    static fill_average_rated_speed_of_the_fan(store, measurementTmp, fanObj) {
        //fanObj.params['average_rated_speed_of_the_fan'] = (this.getNetwork_frequency(store) / 50) * measurementTmp.data.avg_nominal_speed;
        // NVS-216 - zmiana sposobu obliczania średnich obrotów do tabeli wynikowej
        fanObj.params['average_rated_speed_of_the_fan'] = ((measurementTmp.graphsObj.workPointResult.Frequency / 50) * fanObj.data.avg_nominal_speed).toFixed(0);
    }

    static fill_fan_temperature_increase(store, measurementTmp, fanObj) {
        if(!measurementTmp.graphsObj.workPointResult.TotalPressure.oryginal || !measurementTmp.graphsObj.workPointResult.AirDensity || !measurementTmp.graphsObj.workPointResult.TotalEfficiency.oryginal) return false;

        fanObj.params['fan_temperature_increase'] = measurementTmp.graphsObj.workPointResult.TotalPressure.oryginal / (measurementTmp.graphsObj.workPointResult.AirDensity * 1000 * measurementTmp.graphsObj.workPointResult.TotalEfficiency.oryginal) + 273.15;
    }

    // NVS-77 - uzupełnienie parametrów maksymalną temperaturą wentylatora
    static fill_max_medium_temperature(fan, measurementTmp, fanObj) {
        fanObj.params['max_medium_temperature'] = parseFloat(fan.medium_temperature_to) + 273.15;
    }

    // NVS-83 - obliczenie wartości hałasu Lpa i Lwa
    // NVS-211 - lwa obliczane wg nowego sposobu
    static fill_noise_lpa(store, measurementTmp, fanObj) {
        fanObj.params['noise_lpa'] = 10 * Math.log10(Math.pow(10, (measurementTmp.graphsObj.workPointResult.Noise.oryginal - 9 * Math.log10(fanObj.engine.noise)) / 10) + Math.pow(10, fanObj.engine.noise / 10))
    }
    static fill_noise_lwa(store, measurementTmp, fanObj, number_of_fans) {
        const sum = (arr) => 10 * Math.log10(arr.reduce((total, item) => total + Math.pow(10, item.value / 10), 0));
        const performance = measurementTmp.graphsObj.workPointResult.Performance.oryginal / number_of_fans;
        const totalPressure = measurementTmp.graphsObj.workPointResult.TotalPressure.oryginal;
        const ratedSpeed = ((measurementTmp.graphsObj.workPointResult.Frequency / 50) * fanObj.data.avg_nominal_speed).toFixed(0);
        const noise = 9 * Math.log10(performance) + 20 * Math.log10(totalPressure) + 10 * Math.log10(ratedSpeed);
        const p2 = Object.entries(Object.entries(store.state.OctaveNoiseLwaList).find(item => item[1].name == 'p2'))[1][1];
        if (!p2) {
            fanObj.params['noise_lwa'] = noise;
            return;
        }
        let octaves = [];

        for (const [key, value] of Object.entries(Object.entries(Object.entries(store.state.OctaveNoiseList).find(item => item[1].rpm == Math.ceil(ratedSpeed / 50) * 50))[1][1])) {
            if(key.startsWith('l_')) {
                octaves.push({ key, value: noise - value });
            }
        }
        octaves = octaves.map(item => ({ ...item, value: item.value - Number(p2[item.key]) }));
        octaves = octaves.map(item => ({ ...item, value: item.value + (noise - sum(octaves)) + Number(p2[item.key]) }));

        fanObj.params['noise_lwa'] = sum(octaves);
    }

    static fill_maximum_rotor_speed(fan, measurementTmp, fanObj) {
        fanObj.params['maximum_rotor_speed'] = fan.max_speed;
    }

    static fill_electrical_power(fan, measurementTmp, fanObj, number_of_fans) {
        fanObj.params['electrical_power'] = (measurementTmp.graphsObj.workPointResult.PowerOnShaftWithMaterial / parseFloat(fanObj.engine.efficiency_3_4)) * number_of_fans;
    }

    static fill_number_of_fans(fanObj) {
        // fanObj.params['number_of_fans'] = 2;
        // fanObj.data['number_of_fans'] = 2;
    }

    static fill_drive_select_params(fanObj, fan) {
        fanObj.params['drive'] = "drive_"+fan.drive;
    }

    static fill_weight(fan, measurementTmp, fanObj) {
        fanObj.params['weight'] = parseFloat(fan.mass) + parseFloat(fanObj.engine.weight);
    }

    static fill_material_amount(store, measurementTmp, fanObj) {
        fanObj.params['material_amount'] = measurementTmp.data.workPointAmount;
    }

    static fill_minimum_frequency_on_the_inverter(store, fan, measurementTmp, fanObj) {
        var maximum_pressure = 0;
        var pressureType = this.getPressureType(store)
        var workPressure = 0;

        if (pressureType == "total") {
            maximum_pressure = measurementTmp.graphsObj.fan.lines.TotalPressure.fun(measurementTmp.graphsObj.graphs.TotalPressure.minX);
            workPressure = measurementTmp.graphsObj.workPointResult.TotalPressure.oryginal
        } else {
            maximum_pressure = measurementTmp.graphsObj.fan.lines.StaticPressure.fun(measurementTmp.graphsObj.graphs.StaticPressure.minX);
            workPressure = measurementTmp.graphsObj.workPointResult.StaticPressure.oryginal
        }

        if (this.GetSelectedElementOfOption(store.state.fourthStepParametersSelected.number_of_fans_on_the_inverter.options[0].elements) == "0") {
            fanObj.params['minimum_frequency_on_the_inverter'] = this.GetSelectedElementOfOption(store.state.fourthStepParametersSelected.network_frequency.options[0].elements);
        } else {
            fanObj.params['minimum_frequency_on_the_inverter'] = Math.sqrt((workPressure / maximum_pressure) * Math.pow(this.getNetwork_frequency(store), 2));
            if (fanObj.params['minimum_frequency_on_the_inverter'] < fan.min_frequency)
                fanObj.params['minimum_frequency_on_the_inverter'] = fan.min_frequency;
        }
    }

    static fill_average_length_of_the_shredded_material(store, measurementTmp, fanObj) {
        if (measurementTmp && measurementTmp.data) {
            let v_wlot = measurementTmp.graphsObj.workPointResult.Performance.oryginal / (Math.PI * 0.25 * Math.pow((0.001 * measurementTmp.data.avg_inlet), 2));
            let average_rated_speed_of_the_fan = (this.getNetwork_frequency(store) / 50) * measurementTmp.data.avg_nominal_speed;

            let l_sr = v_wlot / ((this.getNetwork_frequency(store) / 50) * average_rated_speed_of_the_fan / 60 * measurementTmp.data.blades_amount);
            fanObj.params['average_length_of_the_shredded_material'] = l_sr;
        } else {
            fanObj.params['average_length_of_the_shredded_material'] = 0;
        }
    }

    static fill_pipeline_average_speed(store, measurementTmp, fanObj, number_of_fans) {
        fanObj.params['pipeline_average_speed'] = parseFloat((Number.parse(measurementTmp.graphsObj.workPointResult["Performance"].oryginal) / (Math.PI * Math.pow((store.state.fourthStepParametersSelected.pipeline_diameter.value / 2), 2))) * number_of_fans).format(2)
    }

    static fill_characteristic_coefficient(measurementTmp, fanObj) {
        fanObj.params['characteristic_coefficient'] = parseFloat(fanObj.data['characteristic_coefficient']).toFixed(3);
    }

    static fill_minimum_amount_of_air_at_the_minimum_frequency(store, fan, measurementTmp, fanObj) {
        let minimum_frequency_on_the_inverter = 0;
        var maximum_pressure = 0;
        var pressureType = this.getPressureType(store);
        var workPressure = 0;

        if (pressureType == "total") {
            maximum_pressure = measurementTmp.graphsObj.fan.lines.TotalPressure.fun(measurementTmp.graphsObj.graphs.TotalPressure.minX);
            workPressure = measurementTmp.graphsObj.workPointResult.TotalPressure.oryginal
        } else {
            maximum_pressure = measurementTmp.graphsObj.fan.lines.StaticPressure.fun(measurementTmp.graphsObj.graphs.StaticPressure.minX);
            workPressure = measurementTmp.graphsObj.workPointResult.StaticPressure.oryginal
        }

        if (this.GetSelectedElementOfOption(store.state.fourthStepParametersSelected.number_of_fans_on_the_inverter.options[0].elements) == "0") {
            minimum_frequency_on_the_inverter = this.GetSelectedElementOfOption(store.state.fourthStepParametersSelected.network_frequency.options[0].elements);
        } else {
            minimum_frequency_on_the_inverter = Math.sqrt((workPressure / maximum_pressure) * Math.pow(fanObj.data.network_frequency, 2));

            if (fanObj.params['minimum_frequency_on_the_inverter'] < fan.min_frequency)
                minimum_frequency_on_the_inverter = fan.min_frequency;
        }

        fanObj.params['minimum_amount_of_air_at_the_minimum_frequency'] = (minimum_frequency_on_the_inverter / measurementTmp.graphsObj.workPointResult.Frequency) * measurementTmp.graphsObj.graphs.StaticPressure.minX;
    }

    static fill_pipeline_diameter(store, fanObj) {
        fanObj.params['pipeline_diameter'] = store.state.fourthStepParametersSelected.pipeline_diameter.value;
    }


    static fill_amperage_v1(measurementTmp, fanObj, store, number_of_fans) {
        let frequency = this.getNetwork_frequency(store);

        let voltage = fanObj.engine['voltage_' + frequency + '_hz'];
        let voltages = null;

        if (voltage) {
            voltages = voltage.split("/");
        }

        if (voltages && voltages.length > 0)
            fanObj.params['amperage_v1'] = 1000 * (measurementTmp.graphsObj.workPointResult.PowerOnShaftWithMaterial / (voltages[0] * Math.sqrt(3) * fanObj.engine.power_factor * fanObj.engine.efficiency_3_4)) * number_of_fans;
        else
            fanObj.params['amperage_v1'] = 0;
    }

    static fill_amperage_v2(measurementTmp, fanObj, store, number_of_fans) {
        let frequency = this.getNetwork_frequency(store);

        let voltage = fanObj.engine['voltage_' + frequency + '_hz'];
        let voltages = null;

        if (voltage) {
            voltages = voltage.split("/");
        }

        if (voltages && voltages.length > 1)
            fanObj.params['amperage_v2'] = 1000 * (measurementTmp.graphsObj.workPointResult.PowerOnShaftWithMaterial / (voltages[1] * Math.sqrt(3) * fanObj.engine.power_factor * fanObj.engine.efficiency_3_4)) * number_of_fans;
        else
            fanObj.params['amperage_v2'] = 0;
    }

    static fill_material_density(measurementTmp, fanObj, number_of_fans) {
        fanObj.params['material_density'] = Number.parse((measurementTmp.graphsObj.data['workPointAmount']) / 3.6 / Number.parse(measurementTmp.graphsObj.workPointResult["Performance"].oryginal) / number_of_fans / 1000);
    }

    static fill_power_on_shaft_with_material(measurementTmp, fanObj, number_of_fans) {
        fanObj.params['power_on_shaft_with_material'] = measurementTmp.graphsObj.workPointResult.PowerOnShaftWithMaterial.oryginal * number_of_fans;
    }

    static fill_power_on_shaft(measurementTmp, fanObj, number_of_fans) {
        fanObj.params['power_on_shaft'] = measurementTmp.graphsObj.workPointResult.PowerOnShaft.oryginal * number_of_fans;
    }

    static fill_number_of_poles(measurementTmp, fanObj) {
        fanObj.params['number_of_poles'] = this.getNumber_of_poles(measurementTmp.data.engine_rpm);
    }

    static fill_price(fan, measurementTmp, store, fanObj, extensionInfo, number_of_fans) {
        let fanPrice = store.state.pricesList.find(x => x.id == fan.id_price);
        let enginePrice = store.state.pricesList.find(x => x.id == fanObj.engine.id_price);
        let price = 0;

        if (fanPrice && enginePrice && fanPrice.hasOwnProperty("constant") && enginePrice.hasOwnProperty("constant")) {
            fanPrice = parseFloat(fanPrice.constant);
            enginePrice = parseFloat(enginePrice.constant);

            price = (enginePrice + fanPrice) * number_of_fans;

            if (price > 0 && extensionInfo && extensionInfo.name_prefix != "") {
                let selectedRelationAtex = store.state.relationsFanAtexes.find(x => x.fan_id == fan.id && x.id == extensionInfo.id);
                if (selectedRelationAtex) {
                    let version = store.state.fansVersionsList.find(x => x.id == selectedRelationAtex.version_id)

                    if (version) {
                        price = priceController.calculatePrice(fanPrice, enginePrice, store.state.pricesList.find(x => x.id == version.id_price)) * number_of_fans;
                    } else {
                        price = 0;
                    }

                } else {
                    price = 0;
                }
            }
        }

        fanObj.params['price'] = price;
    }


    static fill_rotor_type(measurementTmp, fanObj) {
        fanObj.params['rotor_type'] = "rotor_" + measurementTmp.data.rotor_type;
    }

    static fill_casing_dimensions(fan, store, fanObj) {
        if (!fan || !fan.external_dimensions)
            return false;

        if (store.state.fansTableData.params_table["casing_dimensions"].type == "text")
            fanObj.params['casing_dimensions'] = fan.external_dimensions;

    }

    static fill_air_density(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.AirDensity)
            return false;

        fanObj.params['air_density'] = measurement.graphsObj.workPointResult.AirDensity;
    }

    static fill_noise(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.Noise)
            return false;

        fanObj.params['noise'] = measurement.graphsObj.workPointResult.Noise.oryginal;
    }

    static fill_work_frequency(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.Frequency)
            return false;

        fanObj.params['work_frequency'] = parseFloat(measurement.graphsObj.workPointResult.Frequency);
    }

    static fill_static_efficiency(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.StaticEfficiency)
            return false;

        fanObj.params['static_efficiency'] = measurement.graphsObj.workPointResult.StaticEfficiency.oryginal;
    }

    static fill_total_efficiency(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.TotalEfficiency)
            return false;

        fanObj.params['total_efficiency'] = measurement.graphsObj.workPointResult.TotalEfficiency.oryginal;
    }

    static fill_dynamic_pressure(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.DynamicPressure)
            return false;

        fanObj.params['dynamic_pressure'] = measurement.graphsObj.workPointResult.DynamicPressure.oryginal;
    }

    static fill_static_pressure(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.StaticPressure)
            return false;
            
        fanObj.params['static_pressure'] = measurement.graphsObj.workPointResult.StaticPressure.oryginal;
    }

    static fill_static_pressure_increase(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.StaticPressureIncrease)
            return false;
        
        fanObj.params['static_pressure_increase'] = measurement.graphsObj.workPointResult.StaticPressureIncrease.oryginal;
    }

    static fill_total_pressure(measurement, store, fanObj) {
        if (!measurement.graphsObj.workPointResult.TotalPressure)
            return false;

        fanObj.params['total_pressure'] = measurement.graphsObj.workPointResult.TotalPressure.oryginal;
    }

    static fill_performance(measurement, store, fanObj, number_of_fans) {
        if (!measurement.graphsObj.workPointResult.Performance)
            return false;

        fanObj.params['performance'] = measurement.graphsObj.workPointResult.Performance.oryginal * number_of_fans;
    }

    static fill_temperature(fan, store, fanObj) {
        let storeTemperature = store.state.fourthStepParametersSelected.temperature.value - 273.15;
        fanObj.params['temperature'] = storeTemperature;
        return true;
    }

    static isWorkPointValid(measurement) {
        return measurement && measurement.graphsObj && measurement.graphsObj.workPointResult;
    }

    // NVS-82 Zmiana ze sztywnego przypisania ilości biegunów silnika
    // Wcześniej: 3000 => 2, 1500 => 4, 1000 => 6, 750 => 8, domyślnie => 0
    static getNumber_of_poles(engine_rpm) {
        return 3000 / parseInt(engine_rpm) * 2
    }

    static getPressureType(store) {
        for (let optionId in store.state.fourthStepParametersSelected.pressure.options) {
            let option = store.state.fourthStepParametersSelected.pressure.options[optionId];
            if (option.type && option.type == "radio") {
                for (let elementId in option.elements) {
                    let element = option.elements[elementId];

                    if (element.active)
                        return element.value;
                }
            }
        }
    }

    static getNetwork_frequency(store) {
        for (let optionId in store.state.fourthStepParametersSelected.network_frequency.options) {
            let option = store.state.fourthStepParametersSelected.network_frequency.options[optionId];
            if (option.type && option.type == "radio") {
                for (let elementId in option.elements) {
                    let element = option.elements[elementId];

                    if (element.active)
                        return element.value;
                }
            }
        }
    }

    static GetSelectedElementOfOption(elements) {
        for (let elementId in elements) {
            if (elements.hasOwnProperty(elementId) && elements[elementId].active == true)
                return elements[elementId].value;
        }

        return null;
    }
}

export {fanObjParamsManager}